import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItem} from './SidebarMenuItem'
import {P2cMenu} from '@/app/modules/p2c/Menu'
import AnalyticsMenu from '@/app/modules/analytics/Menu'
import {CoreMenu} from '@/app/modules/core/Menu'


const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'CORE.MENU.DASHBOARD'})}
      />

      <AnalyticsMenu />

      <P2cMenu />

      <CoreMenu />
    </>
  )
}

export {SidebarMenuMain}
